import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  gastosList,
  gastosListSelectBox,
  gastosCreate,
  gastosRead,
  gastosUpdate,
  gastosDelete,  
} = actions;

const gastosListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/gastos/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(gastosList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const gastosCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/gastos/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const gastosReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/gastos/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(gastosRead(response.data.data));
          return true;
        }
      } else {
        dispatch(gastosRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  gastosListAction,
  gastosCreateAction,
  gastosReadAction,    
};
